<mat-toolbar class="bar-filler"></mat-toolbar>
<div class="small-margin small-padding">
    <div class="flex-container-center list-cell" (click)="setHasPayCard(0)">
        <div mat-ripple [ngClass]="{'cell-switch-filled':hasPaycard === 0, 'cell-switch':hasPaycard === 1 || hasPaycard === -1}"></div>
        <div class="list-cell-label small-padding block">{{'Pages.PayCard.NoPaycard' | translate}}</div>
    </div>
    <div class="flex-container-center list-cell" (click)="setHasPayCard(1)">
        <div mat-ripple [ngClass]="{'cell-switch-filled':hasPaycard === 1, 'cell-switch':hasPaycard === 0 || hasPaycard === -1}"></div>
        <div class="list-cell-label small-padding block">{{'Pages.PayCard.HasPaycard' | translate}}</div>
    </div>
    <div *ngIf="hasPaycard === 1">
        <div style="height: 10px;"></div>
        <mat-form-field>
            <mat-label>{{'Pages.PayCard.PaycardNumber' | translate}}</mat-label>
            <input matInput type="number" name="payCardNumber" [(ngModel)]="payCardNumber">
        </mat-form-field>
    </div>
</div>
<mat-divider></mat-divider>
<mat-toolbar class="bar-filler"></mat-toolbar>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.PayCard.Title' | translate}}</div>
</mat-toolbar>
<mat-toolbar color="primary" class="bottom-bar">
    <mat-toolbar-row>
        <button mat-flat-button color="accent" (click)="goOn()" class="fill-parent-width">Confirmar</button>
    </mat-toolbar-row>
</mat-toolbar>